import { gql } from '@apollo/client';

export const FINANCIAL_PRODUCT_REMOVED = gql`
  subscription financialProductDeleted {
    financialProductDeleted {
      productId
    }
  }
`;

export const FINANCIAL_PRODUCT_DUPLICATED = gql`
  subscription financialProductDuplicated {
    financialProductDuplicated {
      productId
    }
  }
`;
